export const PROTOTYPE_STATUS_ORDER = { reference: 0, delivered: 1, ready: 2, review: 3, draft: 4, archived: 5 } as const;

export type PrototypeStatus = keyof typeof PROTOTYPE_STATUS_ORDER;

/** Statuts modifiables depuis le catalogue (`archived` passe par l'action Archiver). */
export const EDITABLE_STATUSES = ['reference', 'draft', 'review', 'ready', 'delivered'] as const satisfies readonly PrototypeStatus[];

export function isEditableStatus(value: unknown): value is (typeof EDITABLE_STATUSES)[number] {
  return typeof value === 'string' && (EDITABLE_STATUSES as readonly string[]).includes(value);
}
